export default __webpack_public_path__ + "static/media/20051.4ef27aa8.jpg";